RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    /*
     * Layout version of Dashboard.views.Widgets to support toolbar
     */
    views.CurationWidgets = RivalIQ.views.LayoutView.mixin({
        template: '#dashboardWidgetsTemplate',
        collectionView: views.Widgets,

        regions: {
            leftActions: {
                selector: '.x-left-actions-region',
                regionClass: RivalIQ.regions.ListRegion
            },
            actions: {
                selector: '.x-toolbar-actions-region',
                regionClass: RivalIQ.regions.ListRegion
            },
            widgets: '.x-widgets-region'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        // NOTE for the reasoning behind this see
        // https://github.com/RivalIQ/rivaliq-server/pull/8360#discussion_r73018224
        onRender: function () {
            const me = this;

            // Only render the widget region on initial render
            if (!me._isShown) {
                me.showLeftToolbarActions();
                me.showActions();
                me.showWidgets();
            }
        },

        showActions: function () {
            const me = this;
            me.showExportDropdown();
        },

        showLeftToolbarActions: _.noop,
        showExportDropdown: function () {
            const me = this;

            me.actions.show(new views.ExportDropdown({
                model: me.getOption('dashboardModel')
            }), {
                preventDestroy: true
            });
        },
        showWidgets: function () {
            const me = this;
            const View = me.collectionView;
            const collection = me.dashboardModel.getWidgets();

            Marionette.bindEntityEvents(me, collection, me.collectionEvents);

            me.widgets.show(new View({
                collection: me.dashboardModel.getWidgets(),
                dashboardModel: me.dashboardModel
            }));
        }
    });

    function createRow() {
        const rowEl = document.createElement('div');
        rowEl.className = 'row';
        return rowEl;
    }

    function createCol(row, className) {
        const colEl = document.createElement('div');
        colEl.className = className;
        row.appendChild(colEl);
        return colEl;
    }

    /*
     * Splits collection between rows based on column count
     */
    const COLUMN_COUNT = 12;
    views.ColumnWidgets = views.Widgets.extend({
        columnBootstrapSize: 'sm',

        _onCollectionRemove: function () {
            const me = this;
            views.Widgets.prototype._onCollectionRemove.apply(me, arguments);
            if (!me.isEmpty(me.collection)) {
                me.updatePositions();
            }
        },

        getColumnWidth: function (child) {
            const me = this;

            if (me.columnWidth) {
                return me.columnWidth;
            }

            const width = (child.dashboardModel ? child.dashboardModel.getColumnWidth() : undefined);
            return (isNaN(width) ? COLUMN_COUNT : width);
        },

        getColumnClassName: function (columnWidth) {
            const me = this;

            const columnClass = ['col', _.result(me, ['columnBootstrapSize']), columnWidth].join('-');
            return _.compact([me.columnClassName, columnClass]).join(' ');
        },

        onBeforeRemoveChild: function (child) {
            child.rowEl = child.$el.parent().parent();
        },

        // If this view's parent row was emptied by removing this child, detach
        // it
        onRemoveChild: function (child) {
            if (!child.rowEl.children().children().length) {
                child.rowEl.detach();
            }

            delete child.rowEl;
        },

        afterAppendRow: _.noop,
        beforeAppendRow: _.noop,

        _createBuffer: function (children) {
            const me = this;
            const elBuffer = document.createDocumentFragment();

            let row = createRow();

            me.gridIndex = 0;
            _.each(children || me._bufferedChildren, function (child) {
                const childWidth = me.getColumnWidth(child);
                const className = me.getColumnClassName(childWidth);

                if (me._shouldInsertNewRow(childWidth)) {
                    row = createRow();
                    me.beforeAppendRow(child, elBuffer);
                    elBuffer.appendChild(row);
                    me.afterAppendRow(child, elBuffer);
                    me.gridIndex = childWidth;
                } else {
                    me.gridIndex += childWidth;
                }

                const col = createCol(row, className);
                col.appendChild(child.el);
            });

            return elBuffer;
        },

        _shouldInsertNewRow: function (width) {
            const me = this;
            return me.gridIndex === 0 || me.gridIndex + width > COLUMN_COUNT;
        },

        // TODO does not handle insertion in the middle of the collection
        _insertAfter: function (childView) {
            const me = this;

            // Empty view should not get the row treatment
            if (me.isEmpty()) {
                return views.Widgets.prototype._insertAfter.call(me, childView);
            }

            let col;
            const childWidth = me.getColumnWidth(childView);
            const className = me.getColumnClassName(childWidth);
            if (me._shouldInsertNewRow(childWidth)) {
                const row = createRow();
                col = createCol(row, className);
                col.append(childView.el);
                me.el.appendChild(row);
                me.gridIndex = childWidth;
            } else {
                col = createCol(me.$el.find('.row:last')[0], className);
                col.append(childView.el);
                me.gridIndex += childWidth;
            }
        },

        /*
         * Recalculate widget positions and move widgets
         */
        updatePositions: function () {
            const me = this;

            me.setColumnWidth(me.columnWidth);
        },

        /*
         * Move elements around to match the new global column count or handle
         * a new set of children
         */
        setColumnWidth: function (columnWidth) {
            const me = this;
            me.columnWidth = columnWidth;

            const buffer = me._createBuffer(me.children.toArray());
            me.$el.html(buffer);
        }
    });

    /*
     * Layout version of views.ColumnWidgets
     */
    views.ColumnCurationView = views.CurationWidgets.extend({
        collectionView: views.ColumnWidgets,
        showExportDropdown: function () {
            const me = this;
            if (me.collection.length) {
                return views.CurationWidgets.prototype.showExportDropdown.call(me);
            }
        }
    });
});
